import { render, staticRenderFns } from "./EventsDetail.vue?vue&type=template&id=19e5d6cf&scoped=true"
import script from "./EventsDetail.vue?vue&type=script&lang=js"
export * from "./EventsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e5d6cf",
  null
  
)

export default component.exports